 const types = {
  SET_PURCHASED_SERIES: '@content/SET_PURCHASED_SERIES',
  SET_PURCHASED_COMMUNITY: '@content/SET_PURCHASED_COMMUNITY',
  ADD_TO_PURCHASED_SERIES: '@content/ADD_TO_PURCHASED_SERIES',
  ADD_TO_PURCHASED_COMMUNITY: '@content/ADD_TO_PURCHASED_COMMUNITY',
 }

 export default types